// Licensed from NativeLabs, an LR Ventures LLC FZ platform.
import { requestActions } from "./utils";

export const PAGES = requestActions("Wiki/Pages/List");
export const PAGE = requestActions("Wiki/Page/Get");
export const PAGE_UPDATE = requestActions("Wiki/Page/Update");
export const TRASH = requestActions("Wiki/Trash/List");
export const SEARCH = requestActions("Wiki/Search");
export const PAGE_RESET = "Wiki/Page/Reset";
export const SEARCH_RESET = "Wiki/Search/Reset";
